import React from 'react';
import PageLayout from "../layouts/page_layout";
import HomeOneContent from "../components/page_content/home_one_content";
export default function HomeOne() {
  return (
    <PageLayout>
      <HomeOneContent/>
    </PageLayout>
  );
}
